import { render } from "./zp.vue?vue&type=template&id=7be83e3a&scoped=true"
import script from "./zp.vue?vue&type=script&lang=js"
export * from "./zp.vue?vue&type=script&lang=js"

import "./zp.vue?vue&type=style&index=0&id=7be83e3a&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be83e3a"]])

export default __exports__